var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 880,
    height: 880,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.20000002 0 0 0.20000002 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5 0 0 2.5 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9333334 0 0 2.9333334 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 -0 -0.1 0 512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2474 3341L2973 2842L3011 2855C 3139 2900 3233 3002 3266 3131C 3278 3179 3281 3232 3278 3369C 3275 3543 3275 3546 3243 3612C 3204 3695 3135 3766 3055 3806L3055 3806L2995 3835L2485 3838L1975 3840L2474 3341z",
    stroke: "none",
    fill: "#B25068",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 3232C 1620 3228 1855 2990 2143 2702L2143 2702L2665 2180L3005 2180L3345 2180L2815 2710L2285 3240L1953 3240C 1770 3240 1620 3237 1620 3232z",
    stroke: "none",
    fill: "#B25068",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 2465L1740 2180L2027 2180L2315 2180L2030 2465C 1873 2622 1744 2750 1743 2750C 1741 2750 1740 2622 1740 2465z",
    stroke: "none",
    fill: "#B25068",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.240b4f6ba2f6a5b2ab449d3351f6d0a6.svg";
export { ForwardRef as ReactComponent };